import React from 'react'
import {withStyles} from '@material-ui/core';
import styles from './styles'
import {withTranslation} from 'react-i18next';
import {compose} from 'recompose';
import PropTypes from 'prop-types';
import {CarrierAndMicroHubDropdownSelect, DayOfWeekSelect, DropdownSelectSimple, SearchInput} from '../../index';


function CustomerFilter(props) {

  const {classes, className, t, filter, setFilter, carriersWithMicroHubs, shipperOptions, microHubOptions, searchInput, setSearchInput} = props;

  return (
    <div className={className}>
      <form className={classes.row}>
        <DropdownSelectSimple
          hideOnEmptyOptions
          name={t('shipper')}
          options={shipperOptions}
          setValue={(value) => setFilter({...filter, shipperName: value})}
          sort
          value={filter.shipperName}
        />
        <CarrierAndMicroHubDropdownSelect
          carriersWithMicroHubs={carriersWithMicroHubs}
          carrierValue={filter.carrierName}
          className={classes.row}
          microHubOptions={microHubOptions}
          microHubValue={filter.microHubName}
          setCarrierValue={(value) => setFilter({...filter, carrierName: value, microHubName: ''})}
          setMicroHubValue={(value) => setFilter({...filter, microHubName: value})}
        />
        <DayOfWeekSelect
          setValue={(value) => setFilter({...filter, dayOfWeek: value})}
          value={filter.dayOfWeek}
        />
        <SearchInput
          descriptionKey={'1'}
          setValue={(value) => setSearchInput(value)}
          value={searchInput}
        />
      </form>
    </div>
  );
}


CustomerFilter.propTypes = {
  carriersWithMicroHubs: PropTypes.object,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  filter: PropTypes.object.isRequired,
  microHubOptions: PropTypes.array,
  searchInput: PropTypes.string.isRequired,
  setFilter: PropTypes.func.isRequired,
  setSearchInput: PropTypes.func.isRequired,
  shipperOptions: PropTypes.array,
  t: PropTypes.func.isRequired
};

export default compose(withStyles(styles), withTranslation())(CustomerFilter);
